import { render, staticRenderFns } from "./FileQuestion.vue?vue&type=template&id=ed8169c2&"
import script from "./FileQuestion.vue?vue&type=script&lang=js&"
export * from "./FileQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports